/* eslint-disable import/prefer-default-export */
import { TAB_KEY } from '@/shared/config';

// Ánh xạ keyNumber (TAB_KEY, giữ nguyên số cũ) -> tên tab gửi cho pingAiApi (backend key theo chuỗi này).
const TAB_ENUM: Record<string, string> = {
  [TAB_KEY.BEATS]: 'BEATS_HR', // '1'
  [TAB_KEY.ECG_EVENTS]: 'ECG_EVENTS', // '2'
  [TAB_KEY.HR_SUMMARY]: 'HR_SUMMARY', // '6'
  [TAB_KEY.STRIPS_MANAGEMENT]: 'STRIPS_MANAGEMENT', // '3'
  [TAB_KEY.PDF_REPORT]: 'PDF_REPORT', // '4'
};

export { TAB_ENUM };
